import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

const API = process.env.REACT_APP_API_BASE_URL;

const ProductReviewView = () => {
  const { id } = useParams();
  const [review, setReview] = useState(null);
  const [loading, setLoading] = useState(true);

  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, def) => translations[key] || def;

  useEffect(() => {
    const fetchReview = async () => {
      try {
        const token = localStorage.getItem("admin_token");

        const res = await axios.get(`${API}/api/product-reviews/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setReview(res.data);
      } catch (err) {
        console.error("Review alınamadı", err);
      } finally {
        setLoading(false);
      }
    };

    fetchReview();
  }, [id]);

  if (loading) return <div>{getText("LOADING_TEXT")}</div>;
  if (!review) return <div>{getText("DATA_NOT_FOUND")}</div>;

  return (
    <div className="card p-4">
      <h4 className="fw-bold mb-3">{review.title}</h4>

      <p>
        <strong>{getText("RATING_LABEL")}:</strong>{" "}
        {"⭐".repeat(review.rating)}
        <span className="ms-2 text-muted">
          ({review.rating}/5)
        </span>
      </p>

      <p className="mt-3">
        <strong>{getText("COMMENT_LABEL")}:</strong>
      </p>

      <div className="border p-3 rounded bg-light">
        {review.content}
      </div>
    </div>
  );
};

export default ProductReviewView;
